/**
 * ValveMan Valve Finder: progressive enhancement only (Phase 2, Oct 2026).
 * Every step is a server-rendered page and every option a real link, so the flow works
 * with this file blocked. It adds: the header-height variable for the sticky rail, live
 * type counts, the final-answer beat, prefetch, keyboard (roving grid, Escape = back),
 * the in-flow chat behaviour, resume, the results strip and Clarity events.
 * Writes only textContent / attributes; never innerHTML.
 */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  // Landing, step, entry and strip each include this file; run it once per page (a second
  // run would bind every listener twice and insert a second strip).
  if (w.__vfBooted) return;
  w.__vfBooted = true;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function store(kind) { try { var s = w[kind]; s.setItem('vf_t', '1'); s.removeItem('vf_t'); return s; } catch (e) { return null; } }
  var ss = store('sessionStorage'), ls = store('localStorage');
  function get(s, k) { try { return s ? JSON.parse(s.getItem(k)) : null; } catch (e) { return null; } }
  function put(s, k, v) { try { if (s) s.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function fill(t, m) { return String(t || '').replace(/\{(\w+)\}/g, function (x, k) { return m[k] != null ? m[k] : x; }); }
  function num(n) { return Number(n).toLocaleString('en-US'); }
  // Every navigation goes through here (tests observe assign vs replace via __vfNav).
  function go(href, replace) { if (typeof w.__vfNav === 'function') return w.__vfNav(href, !!replace); if (replace) location.replace(href); else location.assign(href); }

  /* ---- analytics: existing Clarity only; queued until the idle-loaded tag exists ---- */
  var q = [];
  function flush() {
    var c = w.clarity; if (typeof c !== 'function') return false;
    while (q.length) { var e = q.shift(); try { Object.keys(e.p).forEach(function (k) { c('set', 'vf_' + k, String(e.p[k]).slice(0, 255)); }); c('event', e.n); } catch (x) {} }
    return true;
  }
  var flushTimer = 0;
  function track(n, p) {
    q.push({ n: n, p: p || {} });
    if (!flush() && !flushTimer) { var i = 0; flushTimer = setInterval(function () { if (flush() || ++i > 30) { clearInterval(flushTimer); flushTimer = 0; } }, 1000); }
    try { d.dispatchEvent(new CustomEvent('vm:valve-finder', { detail: { event: n, props: p || {} } })); } catch (x) {}
  }

  /* ---- sticky rail sits under the real fixed header: .vm-sticky-wrap (topbar + header +
     nav), which collapses its upper part on scroll. sections/header.liquid publishes the
     same box as --header-height; this mirrors it into --vf-header-h. ---- */
  var header = $('.vm-sticky-wrap') || $('header');
  function setH() { if (header) root.style.setProperty('--vf-header-h', header.offsetHeight + 'px'); }
  setH();
  if (header && w.ResizeObserver) new ResizeObserver(setH).observe(header);
  w.addEventListener('orientationchange', setH);

  var vf = $('[data-vf]'), strip = $('[data-vf-strip-tpl]'), entry = $('[data-vf-entry]');
  if (vf || strip || entry) d.body.classList.add('vf-page');

  /* ---- chat: the floating launcher is hidden on finder pages by CSS (assets/vm-valve-finder.css,
     unless html.vm-chat-maximized), so it never flashes and never comes back after a bfcache
     Back. The in-flow controls carry data-vm-chat-intent, so the LiveChat controller opens chat
     (and owns the fallback). This script never hides or minimizes chat. ---- */
  w.addEventListener('pagehide', flush);

  /* ---- live family counts for type cards / entry tiles (same source as the steps) ---- */
  var TTL = 600000;
  function typeCount(handle) {
    var key = 'vf_n_' + handle, c = get(ss, key);
    if (c && Date.now() - c.t < TTL) return Promise.resolve(c.n);
    var url = '/collections/' + encodeURIComponent(handle) + '?section_id=vm-facet-json&filter.p.m.custom.is_series_parent=1';
    var ctl = w.AbortController ? new AbortController() : null, timer = setTimeout(function () { if (ctl) ctl.abort(); }, 4000);
    return fetch(url, { credentials: 'same-origin', signal: ctl && ctl.signal }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      clearTimeout(timer);
      var m = /<script type="application\/json" data-vm-facet-json>([\s\S]*?)<\/script>/.exec(h);
      var n = m ? JSON.parse(m[1]).total : null;
      if (typeof n === 'number') put(ss, key, { n: n, t: Date.now() });
      return typeof n === 'number' ? n : null;
    }).catch(function () { clearTimeout(timer); return null; });
  }
  function fillCounts(scope, one, many) {
    $$('[data-vf-type-count]', scope).forEach(function (el) {
      var card = el.closest('[data-vf-handle]'); if (!card) return;
      typeCount(card.getAttribute('data-vf-handle')).then(function (n) {
        if (n == null) return;                       // failure: no number, never a fake zero
        el.textContent = n === 1 ? one : fill(many, { count: num(n) });
        card.setAttribute('data-vf-count', n);
        if (n < 5) el.classList.add('is-low');
        // No families: the type's first question would have nothing to ask and no results
        // to show, so the card stops being a working link (the step page has its own
        // zero screen for anyone who arrives without this script).
        if (n === 0) { card.setAttribute('aria-disabled', 'true'); card.classList.add('is-off'); }
      });
    });
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.vf-card[aria-disabled="true"], a.vf-tile[aria-disabled="true"]');
    if (a) e.preventDefault();
  });

  /* ---- prefetch the next page while a pointer or focus rests on an option ---- */
  var pre = {};
  function prefetch(href) {
    if (!href || pre[href] || Object.keys(pre).length > 12) return;
    pre[href] = 1; var l = d.createElement('link'); l.rel = 'prefetch'; l.href = href; d.head.appendChild(l);
  }
  d.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('a.vf-opt, a.vf-card, a.vf-tile'); if (!a) return;
    clearTimeout(a._vfT); a._vfT = setTimeout(function () { prefetch(a.getAttribute('href')); }, 120);
  });

  /* ---- landing ---- */
  if (vf && vf.getAttribute('data-vf-mode') === 'landing') {
    var cfg = {}; try { cfg = JSON.parse($('[data-vf-config]', vf).textContent); } catch (e) {}
    var copy = cfg.copy || {};
    fillCounts(vf, copy.typeCountOne, copy.typeCount);
    track('vf_open', { surface: 'page', src: (location.hash.match(/src=([\w-]+)/) || [])[1] || 'direct', images_rendered: $$('.vf-plate', vf).length });

    // Resume: one row, never a modal, only when the last state is recent and real.
    var last = get(ls, 'vf_last_state'), row = $('[data-vf-resume]', vf);
    if (row && last && last.url && last.n >= 2 && Date.now() - last.t < 7 * 864e5) {
      var cont = d.createElement('a'); cont.href = last.url; cont.textContent = copy.resumeContinue;
      var fresh = d.createElement('button'); fresh.type = 'button'; fresh.textContent = copy.resumeFresh;
      fresh.addEventListener('click', function () { try { ls.removeItem('vf_last_state'); } catch (e) {} row.hidden = true; track('vf_resume', { choice: 'fresh' }); });
      cont.addEventListener('click', function () { track('vf_resume', { choice: 'continue' }); });
      var t = d.createElement('span'); t.textContent = fill(copy.resume, { answers: last.label });
      row.appendChild(t); row.appendChild(cont); row.appendChild(fresh); row.hidden = false;
    }

    // Roving tabindex: one tab stop for the card grid; arrows move in visual order.
    var grid = $('[data-vf-grid]', vf);
    if (grid) {
      var cards = function () { return $$('a.vf-card', grid).filter(function (c) { return c.offsetParent !== null; }); };
      // Exactly one tab stop always: if the target is not a visible card, the first visible
      // (or, failing that, the first) card keeps it, so the grid is never unreachable.
      var setStop = function (el) {
        var vis = cards(); if (!el || vis.indexOf(el) < 0) el = vis[0] || $('a.vf-card', grid);
        $$('a.vf-card', grid).forEach(function (c) { c.tabIndex = c === el ? 0 : -1; });
      };
      setStop(cards()[0]);
      grid.addEventListener('focusin', function (e) { if (e.target.matches('a.vf-card')) setStop(e.target); });
      grid.addEventListener('keydown', function (e) {
        var list = cards(), i = list.indexOf(d.activeElement); if (i < 0) return;
        var cols = Math.max(1, Math.round(grid.clientWidth / list[0].offsetWidth)), j = i;
        if (e.key === 'ArrowRight') j = (i + 1) % list.length; else if (e.key === 'ArrowLeft') j = (i - 1 + list.length) % list.length;
        else if (e.key === 'ArrowDown') j = (i + cols) % list.length; else if (e.key === 'ArrowUp') j = (i - cols + list.length) % list.length;
        else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = list.length - 1; else if (e.key === ' ') { e.preventDefault(); list[i].click(); return; } else return;
        e.preventDefault(); setStop(list[j]); list[j].focus();
      });
      w.addEventListener('hashchange', function () { setStop(cards()[0]); });
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.vf-card'); if (a) track('vf_answer', { step: 'type', value: a.getAttribute('data-vf-value'), count_after: a.getAttribute('data-vf-count') || '', images_rendered: $$('img', a).length, via: /#vf-job-\d/.test(location.hash) ? 'help' : 'direct' });
      var h = e.target.closest && e.target.closest('[data-vf-help]'); if (h) track('vf_help_pick', { answer: h.getAttribute('data-vf-help') });
    });
  }

  /* ---- a server-rendered step ---- */
  if (vf && vf.getAttribute('data-vf-mode') === 'step') {
    var step = vf.getAttribute('data-vf-step'), count = +vf.getAttribute('data-vf-count');
    var title = $('[data-vf-focus]', vf);
    // No scroll on arrival: a step page has no hero, so the rail already sits directly under
    // the header at the top. (Scrolling it "under the header" put it BEHIND the full,
    // not-yet-condensed header.) Focus moves to the question for screen readers only.
    if (title && d.referrer) title.focus({ preventScroll: true });

    // Count: animate only small changes (a big drop animating reads as a loading bug).
    var n = $('[data-vf-count-n]', vf), before = get(ss, 'vf_prev_count');
    if (n && typeof before === 'number' && !reduce && before !== count && Math.abs(before - count) < 50) {
      var t0 = null; (function tick(ts) { t0 = t0 || ts; var k = Math.min(1, (ts - t0) / 160); n.textContent = num(Math.round(before + (count - before) * k)); if (k < 1) requestAnimationFrame(tick); })(performance.now());
    }
    put(ss, 'vf_prev_count', count);

    // Resume state: the URL is the state; storage only mirrors it.
    var chips = $$('.vf-chip__v', vf).map(function (c) { return c.textContent; });
    var stateRow = { url: location.pathname + location.search, t: Date.now(), n: chips.length, label: chips.join(', ') };
    put(ss, 'vf_state', stateRow); put(ls, 'vf_last_state', stateRow);
    track('vf_open', { surface: 'step', step: step, count: count });

    if (step === 'done') { var auto = $('[data-vf-auto]', vf); if (auto) go(auto.getAttribute('href'), true); }

    // Final answer: a 350 ms confirmation, then a REAL navigation (assign, not replace),
    // so Back from the results returns to this question with every answer intact.
    var navigating = false, viaFinder = false;
    vf.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.vf-opt, [data-vf-now], [data-vf-open]');
      var off = e.target.closest && e.target.closest('.vf-opt.is-off');
      if (off) { e.preventDefault(); var m = $('[data-vf-off-msg]', vf); if (m) { m.textContent = off.getAttribute('data-vf-off'); m.hidden = false; } return; }
      if (!a) { if (e.target.closest && e.target.closest('a[href]')) viaFinder = true; return; }
      if (navigating) { e.preventDefault(); return; }
      viaFinder = true;
      if (a.matches('a.vf-opt')) track('vf_answer', { step: step, value: a.getAttribute('data-vf-value'), count_before: count, count_after: a.getAttribute('data-vf-after') });
      else track(a.hasAttribute('data-vf-now') ? 'vf_skip_ahead' : 'vf_not_sure', { step: step, count: count });
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) { flush(); return; }   // new tab: this page stays
      // Every plain tap navigates exactly once: a second tap before the next page arrives would
      // render the server twice and count the answer twice (pageshow re-arms on bfcache).
      if (!a.hasAttribute('data-vf-final')) { navigating = true; flush(); return; }
      e.preventDefault(); navigating = true; vf.classList.add('is-navigating');
      track('vf_results_click', { step: step, count: a.getAttribute('data-vf-after') }); flush();
      var href = a.getAttribute('href');
      if (reduce) { go(href); return; }
      a.classList.add('is-picked');
      var after = +a.getAttribute('data-vf-after'), lab = $('.vf-count__l', vf);
      var tpl = vf.getAttribute(after === 1 ? 'data-vf-matching-one' : 'data-vf-matching');
      if (n && tpl) { n.textContent = fill(tpl, { count: num(after) }); if (lab) lab.hidden = true; }
      setTimeout(function () { go(href); }, 350);
    });
    vf.addEventListener('keydown', function (e) {
      var off = e.target.closest && e.target.closest('.vf-opt.is-off');
      if (off && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); off.click(); }
    });
    // Escape = Back, but only when the shopper is in the finder itself. The cart drawer, the
    // mega-menu, the mobile menu and "More options" close on Escape without cancelling it, so
    // anything open anywhere on the page (or focus outside [data-vf]) means: not ours.
    var OPEN = 'dialog[open], [aria-modal="true"], details[open], [aria-expanded="true"]';
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      var t = d.activeElement;
      if (!t || !vf.contains(t)) return;
      if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      if (d.querySelector(OPEN)) return;
      var back = $('[data-vf-back]', vf); if (back) { track('vf_back', { step: step, via: 'escape' }); go(back.getAttribute('href')); }
    });
    w.addEventListener('pagehide', function () { if (!navigating && !viaFinder) track('vf_leave', { step: step }); flush(); });
    // Back/forward cache: a restored page must be live again, not frozen mid-beat.
    w.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      navigating = false; viaFinder = false; vf.classList.remove('is-navigating');
      $$('.vf-opt.is-picked', vf).forEach(function (o) { o.classList.remove('is-picked'); });
      var nn = $('[data-vf-count-n]', vf), ll = $('.vf-count__l', vf);
      if (nn) nn.textContent = num(count);
      if (ll) ll.hidden = false;
    });
  }

  /* ---- destination collection: the Finder summary strip (only after a finder handoff) ---- */
  if (strip) {
    // Only when the URL says so: #vf-go = a fresh finder handoff (clears an earlier dismissal),
    // #vf = the strip's own chip links. Reaching the collection any other way (the mega-menu,
    // a facet, later in the same tab) never shows "your results".
    var freshRun = location.hash === '#vf-go';
    if (freshRun) try { ss.removeItem('vf_strip_off'); } catch (e) {}
    if ((freshRun || location.hash === '#vf') && get(ss, 'vf_strip_off') !== location.pathname) {
      var node = d.importNode(strip.content, true), box = node.querySelector('.vf-strip');
      strip.parentNode.insertBefore(node, strip);
      var x = box && box.querySelector('[data-vf-strip-x]');   // "Start a new search" = the landing (it offers resume)
      if (x) x.addEventListener('click', function () { put(ss, 'vf_strip_off', location.pathname); box.remove(); track('vf_strip_dismiss'); });
      track('vf_strip_view', { count: box ? box.getAttribute('data-vf-count') : '' });
    }
  }

  /* ---- entry widget (homepage and anywhere): question 1 only, then hand off ---- */
  if (entry) {
    var ec = {}; try { ec = JSON.parse($('[data-vf-entry-config]', entry).textContent); } catch (e) {}
    if (ec.showCounts) fillCounts(entry, ec.one, ec.many);
    if (w.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { prefetch(en.target.getAttribute('href')); io.unobserve(en.target); } }); });
      $$('a.vf-tile', entry).slice(0, 3).forEach(function (a) { io.observe(a); });
    }
    entry.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.vf-tile, a.vf-entry__job');
      if (a) { track('vf_answer', { step: 'type', value: a.getAttribute('data-vf-value') || 'job', entry_point: ec.source || 'entry' }); flush(); }
    });
  }
})();
